module.exports = __webpack_public_path__ + "img/numpy.5c5c0489.png";